import Map from "./Map";

export const map = {
  init: (store) => {
    const maps = document.querySelectorAll('[id^="sd-map"]');
    [...maps].forEach((mapEl) => new Map(mapEl, store));
  },
};

export default map;
